import { _ } from '@icc/shared/helpers';

export type DeliveryStatus = 'sent' | 'delivered' | 'sent-partially' | 'delivered-partially' | 'not-delivered';

export const DeliveryStatuses: Record<DeliveryStatus, string> = {
    sent: _('DELIVERY|Wysłano'),
    delivered: _('DELIVERY|Dostarczono'),
    'sent-partially': _('DELIVERY|Wysłano częściowo'),
    'delivered-partially': _('DELIVERY|Dostarczono częściowo'),
    'not-delivered': _('DELIVERY|Nie dostarczono'),

};

export const DeliveryStatusesColors: Record<DeliveryStatus, string> = {
    sent: '00bcf2',
    delivered: '47d041',
    'sent-partially':'fff100',
    'delivered-partially': '8764b8',
    'not-delivered': 'ff8c00',
};